import React from "react";
import { formatCoin } from "../../utils/bondWheelHelpers";
import BondPlayConfirmModal from "../bond-play/BondPlayConfirmModal";

const BondWheelLeaveModal = ({ open, game, loading = false, onClose, onConfirm }) => {
  if (!open || !game) return null;

  const entry = Number(game.entryAmount || 0);

  return (
    <BondPlayConfirmModal
      open={open}
      eyebrow="Leave wheel"
      title="Leave this wheel?"
      tone="danger"
      confirmLabel="Leave wheel"
      cancelLabel="Stay"
      loading={loading}
      loadingLabel="Leaving…"
      onClose={onClose}
      onConfirm={onConfirm}
      description={
        <>
          <p>
            You will receive a full refund of <strong>{formatCoin(entry)} COIN</strong>.
          </p>
          <p className="bplay-confirm-muted">Your slice will be removed from the wheel.</p>
        </>
      }
    />
  );
};

export default BondWheelLeaveModal;
